import { render, staticRenderFns } from "./TaskFacturationCommentPopup.vue?vue&type=template&id=3356e2e8&scoped=true"
import script from "./TaskFacturationCommentPopup.vue?vue&type=script&lang=js"
export * from "./TaskFacturationCommentPopup.vue?vue&type=script&lang=js"
import style0 from "./TaskFacturationCommentPopup.vue?vue&type=style&index=0&id=3356e2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356e2e8",
  null
  
)

export default component.exports